import { Component } from '@angular/core';

@Component({
	selector: 'cv-schema-render-room40-skeleton',
	templateUrl: './room-skeleton.component.html'
})
export class Room40SkeletonComponent {

}
